<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" :title="`Client: ${data.client_name} Approval For Sub: ${data.subcontractor_name}`" size="lg" :ok-only="true" ok-title="Close" ok-variant="secondary" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="subApprovalModal" :no-close-on-backdrop="true" scrollable>

            <a :href="`/subcontractors/view/${data.subcontractor_id}`" class="btn btn-sm btn-link mb-2" title="View in a New Tab" target="_blank">View Subcontractor: {{ data.subcontractor_name }}</a>

            <template v-for="result in calculationResults">
            <b-card class="mb-2">
                <h6 slot="header" class="mb-0">
                    <span :class="{'badge': true, 'badge-success': result.metric_status == 'Passed', 'badge-danger': result.metric_status == 'Failed', 'badge-secondary': result.metric_status == 'N/A'}">{{ result.metric_status }}</span>
                    {{ result.metric_name }}
                </h6>

                <div class="row">
                    <div class="col-sm-6">
                        <span class="mb-1 text-muted">Conditions:</span>
                        <ul>
                            <li v-for="cond in result.conditions">
                                <span :class="{'text-success': cond.status == 'Passed', 'text-danger': cond.status == 'Failed', 'text-secondary': cond.status == 'N/A'}">{{ cond.status }}</span>
                                {{ cond.attribute }} ({{ cond.attributeValue }})  {{ cond.logic }} {{ cond.value }}
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-6">
                        <span class="mb-1 text-muted">Rules:</span><br/>
                        <small class="text-info">Minimum Required to Pass: {{ result.min_passing_rules }}</small>
                        <ul>
                            <li v-for="rule in result.rules">
                                <span :class="{'text-success': rule.status == 'Passed', 'text-danger': rule.status == 'Failed', 'text-secondary': rule.status == 'N/A'}">{{ rule.status }}</span>
                                {{ rule.attribute }} ({{ rule.attributeValue }})  {{ rule.logic == '==' ? '=' : rule.logic }} {{ rule.value }}
                                <span v-if="rule.immediate_fail == true" class="badge badge-danger" title="Immediate Failure Rule. If this fails, the whole metric fails.">IFR</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-card>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                openModal: false,
                saving: false,
                errors: {},
                options: [],
                calculationResults: [],
                data: {},
            }
        },

        computed: {

            btnTitle(){
                //If saving
                if(this.saving)
                {
                    return 'Calculating...';
                }

                //Default
                return 'Calculate Approval';
            }
        },

        methods: {

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.calculationResults = [];
                this.errors = {};
            },

            handleOk: function(bvEvt) {

            },

            setModel(approvalResults, data){
                //Set the data
                this.calculationResults = approvalResults;
                this.data = data;
            },

            showModal(){
                //Open the modal
                this.openModal = true;
            },
        },

        mounted() {
            //SEt the height
            //this.$refs.subApprovalModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
            //this.$refs.subApprovalModal.$refs.body.style['min-height'] = window.innerHeight * 0.5 + 'px';
        }
    }
</script>